var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M0 0H20V2H0V0Z"}}),_c('path',{attrs:{"d":"M0 6H20V8H0V6Z"}}),_c('path',{attrs:{"d":"M0 12H20V14H0V12Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }